import { useState, useEffect } from "react";
import "./miles.css";
import ProgressBar from "@ramonak/react-progress-bar";
import { milefetchData } from "../firebaseConfig/milefetch";

const Milestones = () => {
  const [progress, setProgress] = useState(0);

  const [response, setResponse] = useState([]);
  useEffect(() => {
    const interval = setInterval(async () => {
      let temp_data = await milefetchData();
      if (temp_data[5].data.milestone == "True") {
        setProgress(100);
        console.log(progress);
      }
      console.log(temp_data);
      // setResponse(await fetchData());
    }, 1000);
    console.log(response.data);
    return () => clearInterval(interval);
  }, [response]);

  return (
    <div className="header flex flex-col mb-4">
      <h1 className="font-bold text-5xl mt-12 mb-8">🌟 Milestones</h1>
      <ProgressBar
        width="60vw"
        completed={progress}
        transitionDuration={"1s"}
      />
      <div className="header mt-4 p-8 pb-0 border-solid border-neutral-300 border-2 rounded-md mb-8">
        <div className="flex flex-col ">
          <div className="patient pb-8">
            <div className="flex flex-col pl-2.5">
              <h1 className="text-3xl font-bold name1">Walk to the exercise room</h1>
              {progress == 100 ? <h3 className="text-xl"> ✅ Tasks done</h3> : <h3 className="text-xl">❌ Task not done</h3>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Milestones;
